import React from 'react';
import { StyledForms } from '@app/components/styled/form/Form';
import { FormSection } from '@app/components/styled/form/FormSection';
import { DateTimePicker } from '@app/components/form/DateTimePicker.web';
import { UserSelect } from '@app/components/form/selects/features/UserSelect';

export const TimesheetForm = () => {
  return (
    <StyledForms.Form>

      <FormSection.Section>
        <FormSection.Title>Informations du pointage</FormSection.Title>
        <FormSection.Content>

          <UserSelect
            name="userId"
            label="Utilisateur"
            isMultiple={false} />

          <DateTimePicker
            name="clockingIn"
            label="Heure d'arrivée"
            type="datetime-local" />

          <DateTimePicker
            name="clockingOut"
            label="Heure de départ"
            type="datetime-local" />

        </FormSection.Content>
      </FormSection.Section>

    </StyledForms.Form>
  );
};

